import React from "react"
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "src/components/ui/dialog"
import type { PropsWithChildren } from "react"
import { Button } from "src/components/ui/button"
import { InvitationService } from "src/openapi"
import { useAuth } from "src/providers/LoginProvider"
import QRCode from "qrcode"
import liff from "@line/liff"
import { useMediaQuery } from "react-responsive"

type Props = {}

export default function GenerateLineLinkCodeModal({ children }: PropsWithChildren<Props>) {
  const { user } = useAuth()
  const [linkCode, setlinkCode] = React.useState<string>()
  const [linkCodeDataUrl, setlinkCodeDataUrl] = React.useState<string>()
  const [linkUrl, setLinkUrl] = React.useState<string>()
  const isMobile = useMediaQuery({ maxWidth: 1023 })

  const handleGenerateCode = async () => {
    try {
      const result = await InvitationService.encodeLineLinkCode(user?.token)
      setlinkCode(result.linkCode)
      let targetUrl = ""
      if (window.location.hostname !== "localhost") {
        targetUrl = await liff.permanentLink.createUrlBy(
          `${location.origin}/line/account_link?code=${result.linkCode}`
        )
        setLinkUrl(targetUrl)
      } else {
        targetUrl = `http://localhost:3000/line/account_link?code=${result.linkCode}`
        setLinkUrl(targetUrl)
      }

      // デスクトップの場合のみQRコード生成
      if (!isMobile) {
        const dataUrl = await QRCode.toDataURL(targetUrl)
        setlinkCodeDataUrl(dataUrl)
      }
    } catch (e) {
      console.error(e)
    }
  }

  const handleOpenChange = (open: boolean) => {
    if (!open) {
      setlinkCodeDataUrl(undefined)
      setLinkUrl(undefined)
      setlinkCode(undefined)
    }
  }

  return (
    <Dialog onOpenChange={handleOpenChange}>
      <DialogTrigger>{children}</DialogTrigger>
      <DialogContent className="bg-white w-[95vw] max-w-[600px] min-h-[400px] flex flex-col gap-4 p-4 sm:p-8">
        <DialogHeader>
          <DialogTitle>LINEアカウント紐付け</DialogTitle>
          <DialogDescription>
            {isMobile
              ? "LINEアプリとアカウントを紐付けるためのリンクを生成します。"
              : "LINEアプリとアカウントを紐付けるためのQRコードを生成します。"}
            <br />
            {isMobile
              ? "リンクは生成してから5分間有効です。"
              : "コードは生成してから5分間有効です。"}
          </DialogDescription>
        </DialogHeader>
        <div className="w-full flex flex-1 gap-4">
          {isMobile ? (
            // モバイル用レイアウト
            <div className="flex flex-col gap-4 w-full items-center justify-center">
              {!linkUrl ? (
                <Button
                  className="bg-[#00c298] hover:bg-[#00a080] text-white"
                  onClick={handleGenerateCode}
                >
                  紐付けリンクを生成
                </Button>
              ) : (
                <div className="flex flex-col gap-4 items-center">
                  <p className="text-sm text-gray-600 text-center">
                    リンクが生成されました。
                    <br />
                    下のボタンをタップしてLINEアプリで開いてください。
                  </p>
                  <Button
                    className="bg-[#00c298] hover:bg-[#00a080] text-white w-full max-w-xs"
                    onClick={() => (window.location.href = linkUrl)}
                  >
                    LINEで開く
                  </Button>
                </div>
              )}
            </div>
          ) : (
            // デスクトップ用レイアウト
            <>
              <div className="flex flex-col gap-4 items-start justify-between">
                <div className="w-1/2 flex flex-col gap-4"></div>
                <Button
                  className="bg-[#00c298] hover:bg-[#00a080] text-white"
                  onClick={handleGenerateCode}
                >
                  QRコードを生成
                </Button>
              </div>
              <div className="flex flex-col gap-4">
                {linkCodeDataUrl && (
                  <>
                    <img src={linkCodeDataUrl} alt="QRコード" />
                  </>
                )}
                {linkCode && window.location.hostname === "localhost" && (
                  <a href={`http://localhost:3000/line/account_link?code=${linkCode}`}>リンク</a>
                )}
              </div>
            </>
          )}
        </div>
      </DialogContent>
    </Dialog>
  )
}
